// Referenced in Experience.js (import, setup, update)
// Hotspots and main locations
import * as THREE from 'three'
// import Raycaster from './Raycaster.js'
// import { camera } from '../experience/Experience.js'
// import { VertexNormalsHelper } from 'three/examples/jsm/Addons.js'

let ready = false

export default class Hotspots {
    constructor(scene, experience, resources, cameraControls) {
        this.scene = scene;
        this.experience = experience
        this.resources = resources
        this.cameraControls = cameraControls;
        this.mouse = new THREE.Vector2();
        this.frameCounter = 0;

        // Variables in update
        this.scale = new THREE.Vector3()
        this.screenPosition = null;
        this.pos = null
        this.clickedLocation = true;

        this.points = [
            // Trash
            {
                // Beer bottle
                position: new THREE.Vector3(3.82, -0.6, 4.7),
                target: new THREE.Vector3(3.67, -0.65, 4.65), // -.25, -.05, +.05 
                offset: new THREE.Vector3(.15, .15, .15),
                cameraOffset: 5,
                element: document.querySelector('.point-trash-001'),
                id: 'underwater',
                trash: true,
                removed: false
            },
            {
                // Can
                position: new THREE.Vector3(3.75, -0.73, 3.75),
                target: new THREE.Vector3(3.6, -0.81, 3.6),
                offset: new THREE.Vector3(.15, .15, .15),
                cameraOffset: 3,
                element: document.querySelector('.point-trash-002'),
                id: 'underwater',
                trash: true,
                removed: false
            },
            {
                // Foil
                position: new THREE.Vector3(1.1, -0.15, 3),
                target: new THREE.Vector3(1.05, -0.15, 2.97), // -.2, -.2, -.25
                offset: new THREE.Vector3(.05, 0.15, .05),
                cameraOffset: 20,
                element: document.querySelector('.point-trash-003'),
                id: 'underwater',
                trash: true,
                removed: false
            },
            {
                // Plastic bottle
                position: new THREE.Vector3(4.82, -0.1, 5.9),
                target: new THREE.Vector3(4.9, 0, 6.5), // -.25, -.05, +.05 
                offset: new THREE.Vector3(.15, .3, .15),
                cameraOffset: 1,
                element: document.querySelector('.point-trash-004'),
                id: 'underwater',
                trash: true,
                removed: false
            },
            {
                // Trashbag
                position: new THREE.Vector3(5.05, -0.45, 3.3),
                target: new THREE.Vector3(5.05, -0.5, 3.1), // -.25, -.05, +.05 
                offset: new THREE.Vector3(.05, .15, -.05),
                cameraOffset: 3,
                element: document.querySelector('.point-trash-005'),
                id: 'underwater',
                trash: true,
                removed: false
            },

            // Location markers
            // Home
            // TODO: Fix camera when you click on the marker. Needs to reset to what the spawn on home is like, rotate around 0, not POV.
            {
                position: new THREE.Vector3(3.2, .9, 1),
                location: 'center',
                id: 'home',
                element: document.querySelector('.point-marker-center'),
            },
            {
                position: new THREE.Vector3(1, 1.5, -5.8),
                location: 'riverbank',
                id: 'home',
                element: document.querySelector('.point-marker-riverbank'),
            },
            {
                position: new THREE.Vector3(3.1, .115, 3.8),
                location: 'underwater',
                id: 'home',
                element: document.querySelector('.point-marker-underwater'),
            },
            // {
            //     position: new THREE.Vector3(6, 3, 6),
            //     location: 'home',
            //     id: 'home',
            //     element: document.querySelector('.point-marker-home'),
            // },
            // Bezoekerscentrum
            // {
            //     position: new THREE.Vector3(6, 3, 6),
            //     location: 'home',
            //     id: 'bezoekerscentrum',
            //     element: document.querySelector('.point-marker-home-for-bezoekerscentrum'),
            // },
            // // Oever
            // {
            //     position: new THREE.Vector3(3.2, .9, 1),
            //     location: 'bezoekerscentrum',
            //     id: 'riverbank',
            //     element: document.querySelector('.point-marker-bezoekerscentrum-for-oever'),
            // },
            // {
            //     position: new THREE.Vector3(3.1, .615, 3.8),
            //     location: 'onderwater',
            //     id: 'riverbank',
            //     element: document.querySelector('.point-marker-onderwater-for-oever'),
            // },
            // {
            //     position: new THREE.Vector3(6, 3, 6),
            //     location: 'home',
            //     id: 'riverbank',
            //     element: document.querySelector('.point-marker-home-for-oever'),
            // },

            // // Onderwater
            // {
            //     position: new THREE.Vector3(3.2, .9, 1),
            //     location: 'bezoekerscentrum',
            //     id: 'onderwater',
            //     element: document.querySelector('.point-marker-bezoekerscentrum-for-onderwater'),
            // },
            // {
            //     position: new THREE.Vector3(-4, 1.5, -5.8),
            //     location: 'riverbank',
            //     id: 'onderwater',
            //     element: document.querySelector('.point-marker-oever-for-onderwater'),
            // },
            // {
            //     position: new THREE.Vector3(-1, 1, 0),
            //     location: 'home',
            //     id: 'onderwater',
            //     element: document.querySelector('.point-marker-home-for-onderwater'),
            // },

            // Locations
            // Oever
            {
                position: new THREE.Vector3(-1.5, .615, -5.3),
                target: new THREE.Vector3(-1.45, .615, -5.3),
                offset: new THREE.Vector3(.15, .10, .15),
                cameraOffset: 5,
                id: 'riverbank',
                element: document.querySelector('.point-kingfisher'),
            },
            {
                position: new THREE.Vector3(0.8, 0.12, -5.7),
                target: new THREE.Vector3(0.85, 0.12, -5.7),
                offset: new THREE.Vector3(.15, .15, .15),
                cameraOffset: 20,
                id: 'riverbank',
                element: document.querySelector('.point-otter'),
            },
            {
                position: new THREE.Vector3(-1, 0.1, -6.8),
                target: new THREE.Vector3(-0.95, 0.1, -6.75),
                offset: new THREE.Vector3(.15, .15, .15),
                cameraOffset: 20,
                id: 'riverbank',
                element: document.querySelector('.point-bever'),
            },
            {
                position: new THREE.Vector3(-1.6, .48, -5.6),
                target: new THREE.Vector3(-1.55, .48, -5.55),
                offset: new THREE.Vector3(.35, -0.146, .35),
                cameraOffset: 5,
                id: 'riverbank',
                element: document.querySelector('.point-billboard'),
            },
            {
                position: new THREE.Vector3(-0.3, 0.3, -8),
                target: new THREE.Vector3(-0.25, 0.3, -8.05),
                offset: new THREE.Vector3(.15, .15, .15),
                cameraOffset: 20,
                id: 'riverbank',
                element: document.querySelector('.point-people'),
            },
            {
                position: new THREE.Vector3(12.2, 1, -7),
                target: new THREE.Vector3(12.5, 1, -7.03),
                offset: new THREE.Vector3(.15, .5, .15),
                cameraOffset: 30,
                id: 'riverbank',
                element: document.querySelector('.point-forest'),
            },
            {
                position: new THREE.Vector3(-7, 0.3, -6.5),
                target: new THREE.Vector3(-7.07, 0.3, -6.48),
                offset: new THREE.Vector3(.15, .15, .15),
                cameraOffset: 20,
                id: 'riverbank',
                element: document.querySelector('.point-water'),
            },
            {
                position: new THREE.Vector3(-4, 0.15, -8.9),
                target: new THREE.Vector3(-4.01, 0.02, -8.45), // Keeps resetting for some reason?
                offset: new THREE.Vector3(.15, .1, .15),
                cameraOffset: 5,
                id: 'riverbank',
                element: document.querySelector('.point-river'),
            },
            {
                position: new THREE.Vector3(-3.4, 0.3, -12),
                target: new THREE.Vector3(-3.3, 0.25, -12.05),
                offset: new THREE.Vector3(.15, .15, .15),
                cameraOffset: 20,
                id: 'riverbank',
                element: document.querySelector('.point-dike'),
            },
            // Onderwater
            {
                position: new THREE.Vector3(3.9, -.35, 3),
                target: new THREE.Vector3(3.85, -.35, 2.95),
                offset: new THREE.Vector3(.05, .10, .15),
                cameraOffset: 4,
                id: 'underwater',
                element: document.querySelector('.point-alosa'),
            },
            {
                position: new THREE.Vector3(2.4, -.43, 2.25),
                target: new THREE.Vector3(2.35, -.43, 2.2),
                offset: new THREE.Vector3(.15, .15, .15),
                cameraOffset: 15,
                id: 'underwater',
                element: document.querySelector('.point-eel'),
            },
            {
                position: new THREE.Vector3(5.93, -0.3, 4.2),
                target: new THREE.Vector3(5.98, -.3, 4.22),
                offset: new THREE.Vector3(.5, .10, .5),
                cameraOffset: 35,
                id: 'underwater',
                element: document.querySelector('.point-underwater-main'),
            },
            {
                position: new THREE.Vector3(1.8, -.05, 3.5),
                target: new THREE.Vector3(1.75, -.05, 3.5),
                offset: new THREE.Vector3(0.2, .1, .15),
                cameraOffset: 25,
                // position: new THREE.Vector3(1.9, -.05, 3.6),
                // target: new THREE.Vector3(1.75, -.1, 3.5),
                // offset: new THREE.Vector3(.5, .10, .5),
                // cameraOffset: 15,
                id: 'underwater',
                element: document.querySelector('.point-ankerkuil'),
            },
            {
                position: new THREE.Vector3(2.75, -0.45, 4.5),
                target: new THREE.Vector3(2.7, -.45, 4.5),
                offset: new THREE.Vector3(-0.05, .15, -.05),
                cameraOffset: 8,
                id: 'underwater',
                element: document.querySelector('.point-salmon'),
            },
            {
                position: new THREE.Vector3(1.6, -.4, 3.2),
                target: new THREE.Vector3(1.53, -.41, 3.18),
                offset: new THREE.Vector3(0, .05, 0),
                cameraOffset: 20,
                id: 'underwater',
                element: document.querySelector('.point-wood'),
            },
            // // Tracked points
            {
                position: new THREE.Vector3(0, 0, 0),
                target: new THREE.Vector3(-5, -2, -5),
                // offset: new THREE.Vector3(0.3, 0.2, 0.7), // Offset of the point
                // this.model.position.set(3, -.5, 3)
                // offset: new THREE.Vector3(-.35, 3.5, 3.5),
                offset: new THREE.Vector3(-.39, 3.5, 3.5), // Actual offset + origin point position of the model if changed. Somehow x is y here.
                cameraOffset: 1,
                element: document.querySelector('.point-fish'),
                id: 'underwater',
                tracked: true,
                get model() {
                    return experience.world.fish.model.children[1] // Sometimes it's children[1] but change it everywhere else too (CameraTransition.js)
                },
                get transformModel() {
                    return experience.world.fish.model
                }
            },
            {
                position: new THREE.Vector3(-1.8, .615, -6.7),
                target: new THREE.Vector3(-1.85, .615, -6.6), // Doesn't do anything...
                // offset: new THREE.Vector3(0.3, 0.2, 0.7), // Offset of the point
                // this.model.position.set(3, -.5, 3)
                // offset: new THREE.Vector3(-.35, 3.5, 3.5),
                offset: new THREE.Vector3(.67, -1.8, -6.65), // Actual offset + origin point position of the model if changed. Somehow x is y here.
                cameraOffset: 1.2, // Why does this not work as expected on the dragonfly?
                element: document.querySelector('.point-dragonfly'),
                id: 'riverbank',
                tracked: true,
                get model() {
                    return experience.world.dragonfly.model.children[0] // Sometimes it's children[1] but change it everywhere else too (CameraTransition.js)
                },
                get transformModel() {
                    return experience.world.dragonfly.model
                }
            },
        ]

        document.addEventListener("placeholderClicked", (event) => {
            this.locationId = event.detail.placeholder.id
        })
    }

    addEventListeners() {
        window.addEventListener('mousemove', (event) => this.onMouseMove(event), false);
        // window.addEventListener('click', (event) => this.onClick(event), false);
    }

    onMouseMove(event) {
        // Convert the mouse position to normalized device coordinates
        this.mouse.x = (event.clientX / this.experience.sizes.width) * 2 - 1;
        this.mouse.y = -(event.clientY / this.experience.sizes.height) * 2 + 1;
    }

    onClick(event) {
        // Only process events on the canvas
        if (event.target.tagName !== 'CANVAS') return;

        // Update raycaster with mouse and camera
        // this.experience.raycaster.setFromCamera(this.mouse, this.experience.camera.instance);

        // Get intersections
        // const intersects = this.experience.raycaster.intersectObjects(this.placeholders);
        // console.log(intersects)
    }

    setupPlaceholder() {
        this.experience.resources.items.mapModel.scene.traverse((child) => {
            // Check if it's a mesh
            if (child instanceof THREE.Mesh && child.name.includes("Placeholder")) {
                const placeholderMesh = child

                this.points.push = ({
                    position: placeholderMesh.position.clone(), // Clone to avoid reference issues
                    offset: new THREE.Vector3(0, 0, -0.5),
                    target: new THREE.Vector3(-2.49, 0.5, -5.01),
                    id: 'placeholder',
                    placeholder: true,
                    // element: document.querySelector('.point-6'),
                });

                this.placeholders.push({
                    placeholderMesh
                })
            }
        })
    }

    // TODO: Move this in raycaster? Needs to work for hotspots and placeholders.
    // update(raycaster, camera, sizes, scene, sceneReady, frustum, cameraViewProjectionMatrix) {
    update(camera, sizes, points) {
        // Delay the start of showing the hotspots
        // sceneReady.on('ready', () => {
        //     // window.setTimeout(() => {
        //     ready = true;
        //     // }, 500)
        // })

        // if (!ready) return;

        for (const point of points) {
            if (this.locationId === point.id) {
                // if (point.location) {
                //     // if (this.clickedLocation) {
                //     this.experience.scene.traverse((child) => {
                //         if (child instanceof THREE.Mesh) {
                //             // console.log(child.name)
                //             if (child.name.includes("Teleport_Point") &&
                //                 child.name.includes("Location") &&
                //                 child.name.includes(`${point.location}`)) {
                //                 const worldPos = new THREE.Vector3();
                //                 const worldScale = new THREE.Vector3();

                //                 child.getWorldPosition(worldPos);
                //                 child.getWorldScale(worldScale);

                //                 this.pos = worldPos;
                //                 this.scale = worldScale;
                //             }
                //         }
                //     })
                //     // this.clickedLocation = false;
                //     // }
                // }
                // Tracked hotspot
                if (point.tracked == true) {
                    this.scale = point.transformModel.scale
                    this.pos = new THREE.Vector3(
                        point.model.position.x * this.scale.x + point.offset.y,
                        point.model.position.y * this.scale.y + point.offset.x,
                        point.model.position.z * this.scale.z + point.offset.z
                    )
                }

                else {
                    if (point.offset) {
                        this.pos = point.position.clone().add(point.offset)
                    } else {
                        this.pos = point.position.clone()
                    }
                }

                // Need this to prevent hotspots from showing up in opposite directions
                const camSpace = this.pos.clone().applyMatrix4(camera.matrixWorldInverse);

                // Hide if behind camera
                if (camSpace.z > 0) {
                    point.element.style.opacity = 0;
                    point.element.style.display = "none";
                    continue;
                }


                this.screenPosition = this.pos.clone().project(camera)

                if (this.screenPosition.x < -1 || this.screenPosition.x > 1 ||
                    this.screenPosition.y < -1 || this.screenPosition.y > 1 ||
                    this.screenPosition.z < -1 || this.screenPosition.z > 1
                ) {
                    // point.element.classList.remove('visible');
                    point.element.style.opacity = 0; // invisible
                    point.element.style.display = "none"
                    continue; // skip raycasting if it's not even on screen
                }

                else {
                    point.element.style.opacity = 1; // visible
                    point.element.style.display = "block"
                }

                const translateX = (this.screenPosition.x * 0.5 + 0.5) * sizes.width
                const translateY = (- this.screenPosition.y * 0.5 + 0.5) * sizes.height

                point.element.style.transform = `translate(${translateX}px, ${translateY}px)`
            }

            else {
                point.element.style.display = "none"
                point.element.style.opacity = 0;
            }
        }
    }
}